export default __webpack_public_path__ + "static/media/151-paper-work.42845945.png";